/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
// import { Item1 } from '../../../_metronic/partials/content/activity/Item1'
// import { Item1 } from '../../../../../../_metronic/partials/content/activity/Item1'
// import { PageTitle } from '../../../_metronic/layout/core'
import WasteDashboard from '../../../../../pages/dashboard/WasteDashboard'
import { PageTitle } from '../../../../../../_metronic/layout/core'
import { MixedWidget10C } from '../../../../../../_metronic/partials/widgets/mixed/MixedWidget10C'
import {
    // ChartsWidget1,
    // ListsWidget4,
    // ListsWidget2,
    // ListsWidget6,
    // StatisticsWidget5,
    // StatisticsWidget6,
    // TablesWidget10,
    // TablesWidget13,
    SankyWidget,
    ChartsWidget3,
    // TablesWidget5,
    // MixedWidget8,
    // TablesWidget2,
} from '../../../../../../_metronic/partials/widgets'
import { TablesWidgetAn } from '../../../../../../_metronic/partials/widgets/tables/TablesWidgetAn'
// import { ChartsWidgetG } from '../../../_metronic/partials/widgets/charts/ChartsWidgetG'
import { ChartsWidgetG } from '../../../../../../_metronic/partials/widgets/charts/ChartsWidgetG'
import { MixedWidget8C } from '../../../../../../_metronic/partials/widgets/mixed/MixedWidget8C'
// import { MixedWidget7 } from '../../../_metronic/partials/widgets'
// import { MixedWidget7 } from '../../../../../../_metronic/partials/widgets'
// import MapComponent from '../../modules/apps/data-administration/data-admininstration-list/Map'
// import MapComponent from '../Map'
// import MapComponentC from '../../modules/apps/data-administration/data-admininstration-list/Map copy'
// import MapComponentC from '../Map copy'
// import { useQuery } from 'react-query'
// import { getUserById } from '../../modules/apps/data-administration/data-admininstration-list/core/_requests'
// import { getUserById } from '../core/_requests'
// import { ChartsWidgetDonut } from '../../../_metronic/partials/widgets/charts/ChartsWidgetDonut'
// import { ChartsWidgetDonut } from '../../../../../../_metronic/partials/widgets/charts/ChartsWidgetDonut'
// import { useAuth } from '../../modules/auth'
import { useAuth } from '../../../../auth'
// import { UsersListHeader } from '../../modules/apps/data-administration/data-admininstration-list/components/header/UsersListHeader'
// import { UsersListHeader } from '../components/header/UsersListHeader'
// import { useFetchCommon } from '../../../_metronic/helpers/crud-helper/useQuery'
import { useFetchCommon } from '../../../../../../_metronic/helpers/crud-helper/useQuery'
// import { generateYearOptions } from '../../modules/apps/data-administration/data-admininstration-list/invenotry/inventoryList'
import { generateYearOptions } from '../invenotry/inventoryList'
// import { useQueryRequest } from '../../modules/apps/data-administration/data-admininstration-list/core/QueryRequestProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
// import { MixedWidget7C1 } from '../../../_metronic/partials/widgets/mixed/MixedWidget7C1'
import { MixedWidget7C1 } from '../../../../../../_metronic/partials/widgets/mixed/MixedWidget7C1'
// import { MixedWidget7C2 } from '../../../_metronic/partials/widgets/mixed/MixedWidget7C2'
import { MixedWidget7C2 } from '../../../../../../_metronic/partials/widgets/mixed/MixedWidget7C2'

import { TablesWidget1 } from '../../../../../../_metronic/partials/widgets'
// import { TablesWidgetC } from '../../../../../../_metronic/partials/widgets/tables/TablesWidgetC'

// import { TablesWidget2Copy } from '../../../_metronic/partials/widgets/tables/TablesWidget2Copy'
// import { TablesWidget2Copy } from '../../../../../../_metronic/partials/widgets/tables/TablesWidget2Copy'
// import { MixedWidget10 } from '../../../_metronic/partials/widgets'
// import { MixedWidget10C } from '../../../_metronic/partials/widgets/mixed/MixedWidget10C'
// import { MixedWidget10C } from '../../../../../../_metronic/partials/widgets/mixed/MixedWidget10C'
// import { Axios } from 'axios'

// import { KTCard } from '../../../../../../_metronic/helpers'
import WastagePieChart from './PieCh'
import SupplyPieChart from './PieCh2'
import TransportationLossesPieChart from './PieCh3'
import { useQuery } from 'react-query'
import { getUserById } from '../core/_requests'
import StatsCard2 from './StatsCards2'
import { CardsWidget17 } from '../../../../../../_metronic/partials/content/cards/Card7'
import { MixedWidget11 } from '../../../../../../_metronic/partials/widgets/mixed/MixedWidget16'


// import { MixedWidget6 } from '../../../../../../_metronic/partials/widgets'

interface Franchise {
    id: string;
    name?: string;
    personalDetails?: {
        name?: string;
    };
}



const DashboardPage = ({ year = '' }: any) => {
    const { isFranchise, currentUser, auth, isSupplyChainManager, isPartner }: any = useAuth()

    // const { responseData: impact } = useFetchCommon({
    //   api: `impact`,
    //   isEnabled: true,
    //   isDropDown: false,
    // })

    // const { responseData: top5Staff } = useFetchCommon({
    //   api: `franchise/topAppUser/${currentUser.id}`,
    //   isEnabled: true,
    //   isDropDown: false,
    // })
    // const { responseData: newMapData } = useFetchCommon({
    //   api: `users?page=0&size=10&type=WASTE_SOURCE`,
    //   isEnabled: true,
    //   isDropDown: false,
    // })

    const { updateState, state } = useQueryRequest()


    const [c2pData, setC2pData] = useState<any>([]);
    const [p2pData, setP2pData] = useState<any>([]);



    const [franchiseList, setFranchiseList] = useState([]);
    const [selectedFranchise, setSelectedFranchise] = useState('');

    const [franchises, setFranchises] = useState<Franchise[]>([]);
    const [selectedFranchiseId, setSelectedFranchiseId] = useState('');
    const [analyticsData, setAnalyticsData] = useState<any>([]);

    // Load franchises on component mount

    const dummyData1 = {
        data: [30, 40, 40, 90, 90, 70, 70, 85, 60, 75, 95, 80],
        label: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    };


    useEffect(() => {
        const loadAnalytics = async () => {
            const authData = localStorage.getItem('kt-auth-react-v');
            const token = authData ? JSON.parse(authData).data.token : '';
            const pickuppointid = authData ? JSON.parse(authData).data.pickuppointid : '';

            if (pickuppointid) {
                // Analytics API
                const response = await fetch(
                    `${process.env.REACT_APP_BASE_API_URL}admin/pickupPoints/analytics/${pickuppointid}?page=0&size=10`,
                    // `https://inclusive-backend-api.asmglobal.co.in/v1/api/admin/pickupPoints/analytics/${pickuppointid}?page=0&size=10`,
                    {
                        headers: { 'Authorization': `Bearer ${token}` }
                    }
                );
                const data = await response.json();
                setAnalyticsData(data);

                // Sankey APIs
                const c2pResponse = await fetch(
                    `${process.env.REACT_APP_BASE_API_URL}sankey/c2p/${pickuppointid}`,
                    {
                        headers: { 'Authorization': `Bearer ${token}` }
                    }
                );
                const c2pData = await c2pResponse.json();
                setC2pData(c2pData);

                const p2pResponse = await fetch(
                    `${process.env.REACT_APP_BASE_API_URL}sankey/p2p/${pickuppointid}/2025`,
                    {
                        headers: { 'Authorization': `Bearer ${token}` }
                    }
                );
                const p2pData = await p2pResponse.json();
                setP2pData(p2pData);

                console.log('C2P Data:', c2pData);
                console.log('P2P Data:', p2pData);
            }
        };

        loadAnalytics();
    }, []);





    console.log("analyticsData is this......", analyticsData.data?.[0].monthlyCollectionTrend)





    // Load analytics when franchise is selected
    // const loadAnalytics = async (franchiseId) => {
    //   const authData = localStorage.getItem('kt-auth-react-v');
    //   const token = authData ? JSON.parse(authData).data.token : '';

    //   const response = await fetch(
    //     `${process.env.REACT_APP_BASE_API_URL}admin/pickupPoints/analytics?page=0&size=10&franchiseeid=${franchiseId}`,
    //     {
    //       headers: { 'Authorization': `Bearer ${token}` }
    //     }
    //   );
    //   const data = await response.json();
    //   setAnalyticsData(data);
    // };


    const [mapLocation, setMapLocation] = useState<any>([])
    const [newMapLocation, setNewMapLocation] = useState<any>([])
    const [newDataMapLocation, setDatanewMapLocation] = useState<any>([])










    // useEffect(() => {
    //   if (newMapData?.length) {
    //     const newMapModify = newMapData.map((x) => {
    //       return {
    //         position: {
    //           lat: x?.address?.latitute,
    //           lng: x?.address?.longitute,
    //         },
    //         name: x?.address?.city,
    //         id: x.id
    //       }
    //     })
    //     setNewMapLocation(newMapModify)
    //   }
    // }, [newMapData])

    useEffect(() => {
        if (mapLocation.length || newMapLocation.length) {
            setDatanewMapLocation([...mapLocation, ...newMapLocation])
        }
    }, [mapLocation, newMapLocation])

    const [collectedGraphData, setCollectedGraphData] = useState<any>({})
    const [suppliedGraphData, setSuppliedGraphData] = useState<any>({})
    const [processGraphData, setProcessGraphData] = useState<any>({})

    // const updateGraphData2 = (trendData, setGraphData, graphData) => {
    //   if (trendData && Object.keys(trendData)?.length > 0) {
    //     const label = Object.keys(trendData).map((date) => {
    //       const [year, month, day] = date.split('-') // Split the date string
    //       return `${month}-${day}` // Format as "day-month"
    //     })
    //     // const data = Object.values(trendData)
    //     // const data = Object.values(trendData)?.map((value: any) => parseFloat(value).toFixed(2))
    //     const data = Object.values(trendData)?.map((value: any) => parseFloat(value) || 0)
    //     setGraphData({ ...graphData, label, data })
    //   }
    // }
    const { responseData: sankey4 } = useFetchCommon({
        api: `sankey/franchise${isSupplyChainManager
            ? `/${auth.data.franchiseId}`
            : currentUser.id
                ? `/${currentUser.id}`
                : ''
            }`,
        // isEnabled: isFranchise || isSupplyChainManager,
        isEnabled: isFranchise || isSupplyChainManager || currentUser.userType === 'PICKUP_POINT_STAFF',
        isDropDown: false,
    })

    // useEffect(() => {
    //   updateGraphData2(collectTrend, setCollectedGraphData, collectedGraphData)
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [collectTrend])

    // useEffect(() => {
    //   updateGraphData2(productionTrend, setProcessGraphData, processGraphData)
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [productionTrend])

    // useEffect(() => {
    //   updateGraphData2(suppliedTrend, setSuppliedGraphData, suppliedGraphData)
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [suppliedTrend])

    const numberItems = [
        // { value: 'collected', name: 'Material collected', icon: 'Collected', color: '#ffffff' },
        // {
        //     value: 'received',
        //     name: 'Material transfer',
        //     icon: 'Production',
        //     color: '#ffffff',
        // },
        // {
        //   value: 'externalSale',
        //   name: 'Material sold to End Users',
        //   icon: 'Dispatched',
        //   color: '#ffffff',
        // },
        { value: 'stock', name: 'Stock', icon: 'stock-new', color: '#ffffff' },
        // {
        //     value: 'inTransitSupply',
        //     name: 'In transit',
        //     icon: 'Customer',
        //     color: '#ffffff',
        // },

        // {
        //     value: 'processed',
        //     name: 'Material processed',
        //     icon: 'emission',
        //     color: '#ffffff',
        // },
    ]




    const [loading, setLoading] = useState(true)
    //   const [logsData, setLogsData] = useState(null)
    //   // const [loading, setLoading] = useState(true)

    //   useEffect(() => {
    //     const fetchLogs = async () => {
    //       try {
    //         // Get token from localStorage
    //         const authData = localStorage.getItem('kt-auth-react-v')
    //         const token = authData ? JSON.parse(authData).data.token : null

    //         const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}logs`, {
    //           headers: {
    //             'Authorization': `Bearer ${token}`,
    //             'Content-Type': 'application/json'
    //           }
    //         })

    //         const result = await response.json()
    //         setLogsData(result)
    //         setLoading(false)
    //       } catch (error) {
    //         console.error('Error fetching logs:', error)
    //         setLoading(false)
    //       }
    //     }

    //     fetchLogs()
    //   }, [])


    // const CarouselRow = ({ analyticsData }) => {
    //     const [currentIndex, setCurrentIndex] = useState(0)

    //     const itemCollectionDetails = analyticsData?.data?.[0]?.itemCollectionDetails || []
    //     const colors = ['primary', 'success', 'info']

    //     const goToPrevious = () => {
    //         setCurrentIndex(prev => prev > 0 ? prev - 3 : Math.max(0, itemCollectionDetails.length - 3))
    //     }

    //     const goToNext = () => {
    //         setCurrentIndex(prev => prev + 3 < itemCollectionDetails.length ? prev + 3 : 0)
    //     }

    //     const visibleItems = itemCollectionDetails.slice(currentIndex, currentIndex + 3)

    //     return (
    //         <>
    //             {/* Navigation buttons */}
    //             {itemCollectionDetails.length > 3 && (
    //                 <div className="d-flex justify-content-between mb-3">
    //                     <button className="btn btn-sm btn-light" onClick={goToPrevious}>
    //                         Previous
    //                     </button>
    //                     <span className="text-dark">
    //                         {currentIndex + 1}-{Math.min(currentIndex + 3, itemCollectionDetails.length)} of {itemCollectionDetails.length}
    //                     </span>
    //                     <button className="btn btn-sm btn-light" onClick={goToNext}>
    //                         Next
    //                     </button>
    //                 </div>
    //             )}

    //             <div className="row g-5 g-xl-8">
    //                 {visibleItems.map((item, index) => (
    //                     <div key={item.itemId} className="col-lg-4">
    //                         <MixedWidget6
    //                             className="mb-3 mb-xl-5"
    //                             chartHeight="150px"
    //                             chartColor={colors[index]}
    //                             data={item}
    //                         />
    //                     </div>
    //                 ))}

    //                 {/* Fill empty slots if less than 3 items */}
    //                 {visibleItems.length < 3 && Array.from({ length: 3 - visibleItems.length }, (_, i) => (
    //                     <div key={`empty-${i}`} className="col-lg-4">
    //                         <MixedWidget6
    //                             className="mb-3 mb-xl-5"
    //                             chartHeight="150px"
    //                             chartColor={colors[visibleItems.length + i]}
    //                         />
    //                     </div>
    //                 ))}
    //             </div>
    //         </>
    //     )
    // }



    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '20px', gap: '10px' }}>

            </div>


            {currentUser?.userType === "PICKUP_POINT_STAFF" ?
                <div className='row' style={{ margin: '20px 0' }}>
                    <div className='col-md-3 col-lg-3 col-xl-3 col-xxl-3 d-flex'>
                        <StatsCard2
                            className='w-100'
                            targetCustomerCount={analyticsData?.data?.[0]?.linkedCustomerCount}
                            actualCustomerCount={analyticsData?.data?.[0]?.activeCustomers}
                            householdpercentage={Math.round((analyticsData?.data?.[0]?.participationRate || 0) * 100)}
                        />
                    </div>
                    <div className='col-md-3 col-lg-3 col-xl-3 col-xxl-3 d-flex'>
                        <CardsWidget17 className='w-100' lifetimeCollection={Math.round(analyticsData?.data?.[0]?.collected || 0)}
                            recyclable={Math.round(analyticsData?.data?.[0]?.materialAnalytics?.breakup?.find(item => item.categoryName === "RECYCLABLE")?.currentYearWeight || 0)}
                            nonRecyclable={Math.round(analyticsData?.data?.[0]?.materialAnalytics?.breakup?.find(item => item.categoryName === "NON RECYCLABLE")?.currentYearWeight || 0)} />
                    </div>
                    <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-6 d-flex'>
                        <MixedWidget11
                            data={analyticsData?.data?.[0]?.yearlyCollected ? (() => {
                                const startYear = new Date().getFullYear() - 2;
                                const endYear = startYear + 5;
                                const years: string[] = [];
                                const plasticValues: number[] = [];
                                const householdValues: number[] = [];

                                for (let year = startYear; year <= endYear; year++) {
                                    years.push(year.toString());
                                    plasticValues.push(analyticsData?.data?.[0].yearlyCollected[year] || 0);
                                    householdValues.push(analyticsData?.data?.[0].yearlyHouseholds[year] || 0);
                                }

                                return {
                                    series1: plasticValues,
                                    series2: householdValues,
                                    categories: years
                                };
                            })() : undefined}
                            className='w-100'
                            chartColor='primary'
                            chartHeight='250px'
                            title='Impact'
                            subtitle='Plastic prevented & Households connected'
                            amount={`${(analyticsData?.data?.[0]?.collected || 0)?.toLocaleString('en', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })} kg`}
                        />
                    </div>
                </div> :
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 0' }}>







                    <div style={{
                        margin: '10px',
                        padding: '16px',
                        borderRadius: '8px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        backgroundColor: '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'start', // ✅ center horizontally
                        flex: 1
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',        // ✅ center vertically inside this row
                            justifyContent: 'center'
                        }}>
                            <div style={{
                                width: '48px',
                                height: '48px',
                                borderRadius: '50%',
                                backgroundColor: '#dff5eb',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: '16px',
                                fontSize: '20px',
                                fontWeight: 'bold',
                                color: '#1a1a1a'
                            }}>
                                <img src="/media/svg/dashboard/New/recycling capacity.png" alt="" style={{ width: '27px', height: '27px' }}></img>
                            </div>

                            <div style={{ textAlign: 'left' }}>
                                <div style={{ fontSize: '16px', fontWeight: '400' }}>Recycling capacity (MT)</div>
                                <div style={{ fontSize: '16px', fontWeight: '700' }}>
                                    {analyticsData?.data?.[0]?.diversionCapacity
                                        ?.find(item => item.name === "Rigid")
                                        ?.capacity || 0}
                                </div>
                            </div>
                        </div>
                    </div>








                    <div style={{
                        margin: '10px',
                        padding: '16px',
                        borderRadius: '8px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        backgroundColor: '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'start', // ✅ center horizontally
                        flex: 1
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',        // ✅ center vertically inside this row
                            justifyContent: 'center'
                        }}>
                            <div style={{
                                width: '48px',
                                height: '48px',
                                borderRadius: '50%',
                                backgroundColor: '#c8f0e8',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: '16px',
                                fontSize: '20px',
                                fontWeight: 'bold',
                                color: '#1a1a1a'
                            }}>
                                <img src="/media/svg/dashboard/New/recycling factory.png" alt="" style={{ width: '27px', height: '27px' }}></img>
                            </div>

                            <div style={{ textAlign: 'left' }}>
                                <div style={{ fontSize: '16px', fontWeight: '400' }}>Facility Name</div>
                                <div style={{ fontSize: '16px', fontWeight: '700' }}>
                                    {analyticsData?.data?.[0]?.pickupPointName}
                                </div>
                            </div>
                        </div>
                    </div>







                    <div style={{
                        margin: '10px',
                        padding: '16px',
                        borderRadius: '8px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        backgroundColor: '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'start', // ✅ center horizontally
                        flex: 1
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',        // ✅ center vertically inside this row
                            justifyContent: 'center'
                        }}>
                            <div style={{
                                width: '48px',
                                height: '48px',
                                borderRadius: '50%',
                                backgroundColor: '#f7f5c5',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: '16px',
                                fontSize: '20px',
                                fontWeight: 'bold',
                                color: '#1a1a1a'
                            }}>

                                <img src="/media/svg/dashboard/New/waste supplier.png" alt="" style={{ width: '27px', height: '27px' }}></img>

                            </div>

                            <div style={{ textAlign: 'left' }}>
                                <div style={{ fontSize: '16px', fontWeight: '400' }}>Waste suppliers</div>
                                <div style={{ fontSize: '16px', fontWeight: '700' }}>
                                    {analyticsData?.data?.[0]?.nosOfCustomer}
                                </div>
                            </div>
                        </div>
                    </div>


                    <div style={{
                        margin: '10px',
                        padding: '16px',
                        borderRadius: '8px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        backgroundColor: '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'start', // ✅ center horizontally
                        flex: 1
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',        // ✅ center vertically inside this row
                            justifyContent: 'center'
                        }}>
                            <div style={{
                                width: '48px',
                                height: '48px',
                                borderRadius: '50%',
                                backgroundColor: '#e4d9f2',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: '16px',
                                fontSize: '20px',
                                fontWeight: 'bold',
                                color: '#1a1a1a'
                            }}>
                                <img src="/media/svg/dashboard/New/Facilities.png" alt="" style={{ width: '27px', height: '27px' }}></img>
                            </div>

                            <div style={{ textAlign: 'left' }}>
                                <div style={{ fontSize: '16px', fontWeight: '400' }}>Address</div>
                                <div style={{ fontSize: '10px', }}>
                                    {analyticsData?.data?.[0]?.pickupPointAddress?.street}
                                </div>
                            </div>
                        </div>
                    </div>



                </div>
            }




            <div className="row">
                {analyticsData?.data?.[0] && (
                    <>
                        <div className="col-6">
                            <MixedWidget10C
                                className='card-xl-stretch mb-xl-8'
                                chartColor='info'
                                chartHeight='150px'
                                title="Material inwards"
                                subtitle="Quantity collected from waste suppliers"
                                amount={`${analyticsData.data[0].collected?.toLocaleString('en', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                }) || '0'} kg`}
                                chartData={analyticsData.data[0].monthlyCollectionTrend}
                            />
                        </div>
                        <div className="col-6">
                            <MixedWidget10C
                                className='card-xl-stretch mb-xl-8'
                                chartColor='warning'
                                chartHeight='150px'
                                title="Material recycled"
                                subtitle="Quantity converted into recycled products"
                                amount={`${analyticsData.data[0].diversionProductionQuantity?.toLocaleString('en', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                }) || '0'} kg`}
                                chartData={analyticsData.data[0].monthlyRecyclingTrend}
                            />
                        </div>
                        <div className="col-6">
                            <MixedWidget10C
                                className='card-xl-stretch mb-5 mb-xl-8'
                                chartColor='primary'
                                chartHeight='150px'
                                title="Material sold"
                                subtitle="Quantity converted into recycled products"
                                amount={`${analyticsData.data[0].externalSale?.toLocaleString('en', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                }) || '0'} kg`}
                                chartData={analyticsData.data[0].monthlySaleTrend}
                            />
                        </div>
                        <div className="col-6">
                            <MixedWidget10C
                                className='card-xl-stretch mb-5 mb-xl-8'
                                chartColor='danger'
                                chartHeight='150px'
                                title="Monthly active households"
                                subtitle="Quantity converted into recycled products"
                                amount={`${analyticsData.data[0].activeCustomers?.toLocaleString('en') || '0'}`}
                                chartData={analyticsData.data[0].montlyActiveCustomers}
                            />
                        </div>
                    </>
                )}
            </div>


            <WasteDashboard analyticsData={analyticsData} />


            {/* 
            {(currentUser.userType === "PICKUP_POINT_STAFF" || currentUser.userType === "FRANCHISE_USER") && (
                <div className="row">
                    <div className="col-4">
                        <MixedWidget10C
                            className='card-xl-stretch mb-xl-8'
                            chartColor='info'
                            chartHeight='150px'
                            title="Material inwards"
                            subtitle="Quantity collected from waste suppliers"
                            amount={analyticsData?.data?.[0].collected?.toFixed(2)}
                            // monthlyCollectionTrend	
                            chartData={analyticsData?.data?.[0].monthlyCollectionTrend}
                        />
                    </div>
                    <div className="col-4">
                        <MixedWidget10C
                            className='card-xl-stretch mb-xl-8'
                            chartColor='warning'
                            chartHeight='150px'
                            title="Material recycled"
                            subtitle="Quantity converted into recycled products"
                            amount={analyticsData?.data?.[0].diversionProductionQuantity?.toFixed(2)}
                            chartData={analyticsData?.data?.[0].monthlyRecyclingTrend}
                        />
                    </div>
                    <div className="col-4">
                        <MixedWidget10C
                            className='card-xl-stretch mb-5 mb-xl-8'
                            chartColor='primary'
                            chartHeight='150px'
                            title="Material sold"
                            subtitle="Quantity converted into recycled products"
                            amount={analyticsData?.data?.[0].externalSale?.toFixed(2)}
                            chartData={analyticsData?.data?.[0].monthlySaleTrend}
                        />
                    </div>
                </div>
            )} */}



            {/* <CarouselRow analyticsData={analyticsData} /> */}


            {/* 

      {(newDataMapLocation?.length && (
        <div>
          <MapComponentC data={newDataMapLocation || []} zooms={12} />
        </div>
      )) ||
        null} */}

            {/* {newDataMapLocation?.length && currentUser.userType === "FRANCHISE_USER" && (
        <div>
          <MapComponentC data={newDataMapLocation || []} zooms={12} />
        </div>
      )}

      {newDataMapLocation?.length && currentUser.userType !== "FRANCHISE_USER" && (
        <div>
          <MapComponent data={newDataMapLocation || []} zooms={12} />
        </div>
      )} */}




            <div className='row g-5 g-xl-8'>
                <div className='col-xl-6'>
                    <TablesWidget1 className="card-xl-stretch mb-xl-8" data={analyticsData} />
                </div>
                <div className='col-xl-6'>
                    {/* <TablesWidgetC className="card-xl-stretch mb-xl-8" /> */}
                    <ChartsWidget3 className="mb-xl-8" data={analyticsData?.data?.[0]?.monthWiseCustomers} />
                </div>
            </div>


            {/* <div style={{ marginTop: "15px" }}>
                <Item1 data={logsData} loading={loading} />
            </div> */}


            {false && <div className="d-flex" style={{ gap: '16px', flex: 1, marginTop: "30px", flexWrap: 'nowrap' }}>
                {/* <div style={{ flex: 1, minWidth: 0 }}>
                    <ChartsWidgetG
                        className="mb-5"
                        label=""
                        data={data.diversionCapacitiesBreakdown}
                    />
                </div> */}
                <div style={{ flex: 1, minWidth: 0 }}>
                    <MixedWidget7C1
                        data={analyticsData?.data?.[0].transportationLossRatio?.toFixed(2)}
                        title='Transportation loss'
                        className='card-xl-stretch mb-xl-8'
                        chartColor='success'
                        chartHeight='200px'
                        note="This data shows the percentage of materials lost while transportation"
                    />
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                    <MixedWidget7C2
                        // data={data?.recyclingRatio}
                        title='Recycling ratio'
                        className='card-xl-stretch mb-xl-8'
                        chartColor='success'
                        chartHeight='200px'
                        note="This data shows the percentage of materials being recycled into circular products"
                    />
                </div>
            </div>}

            {false && <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 0' }}>
                {numberItems.map((eachitems, eachIndex) => {
                    const images = [
                        "/media/svg/dashboard/Production.png",
                        "/media/svg/dashboard/stock-new.png",
                        "/media/svg/dashboard/Customer.png",
                        "/media/svg/dashboard/emission.png"
                    ];

                    const bgColors = [
                        '#dff5eb', // green for Production
                        '#c8f0e8', // teal for stock
                        '#f7f5c5', // yellow for Customer
                        '#e4d9f2'  // purple for emission
                    ];

                    return (
                        <div key={eachIndex + 1 + ''} style={{
                            margin: '10px',
                            padding: '16px',
                            borderRadius: '8px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                            backgroundColor: '#ffffff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'start',
                            flex: 1
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <div style={{
                                    width: '48px',
                                    height: '48px',
                                    borderRadius: '50%',
                                    backgroundColor: bgColors[eachIndex],
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginRight: '16px',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    color: '#1a1a1a'
                                }}>
                                    <img src={images[eachIndex]} alt="" style={{ width: '27px', height: '27px' }} />
                                </div>

                                <div style={{ textAlign: 'left' }}>
                                    <div style={{ fontSize: '16px', fontWeight: '400' }}>{eachitems.name}</div>
                                    <div style={{ fontSize: '24px', fontWeight: '700' }}>
                                        {/* {`${data[eachitems.value]?.toFixed(
                      [
                        'collectionPoints',
                        'diversionFacilities',
                        'wasteDiverters',
                        'lifeImpacted',
                      ].includes(eachitems.value)
                        ? 0
                        : 2
                    ) || ''}${['diversionFacilities', 'wasteDiverters', 'lifeImpacted', 'wastage'].includes(
                      eachitems.value
                    )
                      ? ''
                      : ' kg'
                      }`} */}



                                        {/* {eachitems.value === 'stock'
                                            ? (analyticsData?.data?.[0]?.stock || 0).toFixed(2)
                                            : ''
                                        } */}



                                        <div style={{ fontSize: '24px', fontWeight: '700' }}>
                                            {eachitems.value === 'stock'
                                                ? (analyticsData?.data?.[0]?.stock || 0).toFixed(2)
                                                : eachitems.value === 'received'
                                                    ? (analyticsData?.data?.[0]?.supplied || 0).toFixed(2)
                                                    : eachitems.value === 'processed'
                                                        ? (analyticsData?.data?.[0]?.processed || 0).toFixed(2)
                                                        : ''
                                            }
                                        </div>



                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>}

            {/* <div className='row g-5 g-xl-8'>
                <div className='col-xl-4'>
                    <MixedWidget8C
                        className='card-xl-stretch mb-xl-8'
                        chartColor='primary'
                        chartHeight='150px'
                        data={analyticsData}
                    />
                </div>
                <div className='col-xl-8'>
                    <TablesWidgetAn data={analyticsData} className='card-xl-stretch mb-xl-8' />
                </div>
            </div> */}



            {/* <div className='row g-5 g-xl-8'>
        <div className='col-xl-4'>
          <ListsWidget2 data={[]} className='card-xl-stretch mb-xl-8' />
        </div>
        <div className='col-xl-4'>
          <ListsWidget6 data={[]} className='card-xl-stretch mb-5 mb-xl-8' />
        </div>
        <div className='col-xl-4'>
          <ListsWidget4
            data={[]}
            className='card-xl-stretch mb-xl-8'
            items={5}
          />
        </div>

      </div> */}



            {false && <div className='row g-5 g-xl-8'>
                <div className='col-xl-4'>
                    <TransportationLossesPieChart transportationLosses={analyticsData?.data?.[0]?.transportationLosses}
                        className='card-xl-stretch mb-xl-8' />
                </div>
                <div className='col-xl-4'>
                    <WastagePieChart wastageDetails={analyticsData?.data?.[0]?.wastageDetails}
                        className='card-xl-stretch mb-xl-8' />
                </div>
                <div className='col-xl-4'>
                    <SupplyPieChart suppliedDetails={analyticsData?.data?.[0]?.suppliedDetails}
                        className='card-xl-stretch mb-xl-8' />
                </div>

            </div>}



            <div className='card p-4 mb-3'>
                <p style={{ fontSize: "1.35rem", fontWeight: "bold" }}>Material balance</p>
                <div className="overflow-x-auto" style={{ marginBottom: "20px" }}>
                    <table className="min-w-full" style={{ borderCollapse: "separate", borderSpacing: "15px" }}>
                        <thead>
                            <tr style={{ color: "#9ba1b7", fontSize: "1.075rem" }}>
                                <th className="px-4 py-2 text-left whitespace-nowrap">SN</th>
                                <th className="px-4 py-2 text-left whitespace-nowrap">Category </th>
                                <th className="px-4 py-2 text-left whitespace-nowrap">Item</th>
                                <th className="px-4 py-2 text-left whitespace-nowrap">First Collection</th>
                                <th className="px-4 py-2 text-left whitespace-nowrap">From Facility</th>
                                <th className="px-4 py-2 text-left whitespace-nowrap">Processing</th>
                                <th className="px-4 py-2 text-left whitespace-nowrap">Recycling</th>
                                <th className="px-4 py-2 text-left whitespace-nowrap">To Facility</th>
                                <th className="px-4 py-2 text-left whitespace-nowrap">Sale</th>
                            </tr>
                        </thead>

                        <tbody>
                            {analyticsData?.data?.[0]?.itemWiseTotals?.length > 0 ? analyticsData?.data?.[0]?.itemWiseTotals?.map((item, index) => (
                                <tr key={index} style={{ color: "black", fontSize: "1.075rem", borderBottom: "1px solid #f9f9f9" }}>
                                    <td className="px-4 py-2 whitespace-nowrap">{index + 1}</td>
                                    <td className="px-4 py-2 whitespace-nowrap">{item.categoryName}</td>


                                    {/* <td className="px-4 py-2 whitespace-nowrap">{item.itemName}
                                        <div
                                            style={{
                                                backgroundColor: '#f5f5f5',
                                                padding: '4px 8px',
                                                borderRadius: '6px',
                                                fontSize: '0.875rem',
                                                color: '#666',
                                                marginTop: '4px',
                                                display: 'inline-block',
                                            }}
                                        >
                                            {(item.totalStock || 0).toFixed(2)}
                                        </div>
                                    </td> */}

                                    <td className="px-4 py-2 whitespace-nowrap">{item.itemName}
                                        <div
                                            style={{
                                                backgroundColor: '#f5f5f5',
                                                padding: '4px 8px',
                                                borderRadius: '6px',
                                                fontSize: '0.875rem',
                                                color: '#666',
                                                marginLeft: '10px',
                                                display: 'inline-block',
                                            }}
                                        >
                                            {(item.totalStock || 0).toFixed(2)}
                                        </div>
                                    </td>


                                    <td className="px-4 py-2 whitespace-nowrap">{item.totalC2bQuantity?.toFixed(2)}</td>
                                    <td className="px-4 py-2 whitespace-nowrap">{item.totalB2bQuantity?.toFixed(2)}</td>
                                    <td className="px-4 py-2 whitespace-nowrap">{item.totalProduction?.toFixed(2)}</td>
                                    <td className="px-4 py-2 whitespace-nowrap">{item.totalProductionDiversion?.toFixed(2)}</td>
                                    <td className="px-4 py-2 whitespace-nowrap">{item.totalReturn?.toFixed(2)}</td>
                                    <td className="px-4 py-2 whitespace-nowrap">{item.totalConvert?.toFixed(2)}</td>
                                </tr>
                            )) : (
                                <tr>
                                    <td className="px-4 py-2 text-center">No data available</td>
                                </tr>
                            )}
                        </tbody>


                    </table>
                </div>
            </div>





            <div className='card p-4 mb-3'>
                <p style={{ fontSize: "1.35rem", fontWeight: "bold" }}>SKU wise material collection</p>
                <div className="overflow-x-auto" style={{ marginBottom: "20px" }}>
                    <table className="min-w-full" style={{ borderCollapse: "separate", borderSpacing: "15px" }}>
                        <thead>
                            <tr style={{ color: "#9ba1b7", fontSize: "1.075rem" }}>
                                <th className="px-4 py-2 text-left whitespace-nowrap">Category</th>
                                <th className="px-4 py-2 text-left whitespace-nowrap">Item</th>
                                <th className="px-4 py-2 text-left whitespace-nowrap">Jan</th>
                                <th className="px-4 py-2 text-left whitespace-nowrap">Feb</th>
                                <th className="px-4 py-2 text-left whitespace-nowrap">Mar</th>
                                <th className="px-4 py-2 text-left whitespace-nowrap">Apr</th>
                                <th className="px-4 py-2 text-left whitespace-nowrap">May</th>
                                <th className="px-4 py-2 text-left whitespace-nowrap">Jun</th>
                                <th className="px-4 py-2 text-left whitespace-nowrap">Jul</th>
                                <th className="px-4 py-2 text-left whitespace-nowrap">Aug</th>
                                <th className="px-4 py-2 text-left whitespace-nowrap">Sep</th>
                                <th className="px-4 py-2 text-left whitespace-nowrap">Oct</th>
                                <th className="px-4 py-2 text-left whitespace-nowrap">Nov</th>
                                <th className="px-4 py-2 text-left whitespace-nowrap">Dec</th>
                                <th className="px-4 py-2 text-left whitespace-nowrap">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {analyticsData?.data?.[0]?.itemCollectionDetails?.length > 0 ? analyticsData?.data?.[0]?.itemCollectionDetails.map((item, index) => (
                                <tr key={index} style={{ color: "black", fontSize: "1.075rem", borderBottom: "1px solid #f9f9f9" }}>
                                    <td className="px-4 py-2 whitespace-nowrap">{item.categoryName}</td>
                                    <td className="px-4 py-2 whitespace-nowrap">{item.itemName}</td>
                                    <td className="px-4 py-2 whitespace-nowrap">{item.monthWiseData?.["2025-01"]?.toFixed(2) || "0.00"}</td>
                                    <td className="px-4 py-2 whitespace-nowrap">{item.monthWiseData?.["2025-02"]?.toFixed(2) || "0.00"}</td>
                                    <td className="px-4 py-2 whitespace-nowrap">{item.monthWiseData?.["2025-03"]?.toFixed(2) || "0.00"}</td>
                                    <td className="px-4 py-2 whitespace-nowrap">{item.monthWiseData?.["2025-04"]?.toFixed(2) || "0.00"}</td>
                                    <td className="px-4 py-2 whitespace-nowrap">{item.monthWiseData?.["2025-05"]?.toFixed(2) || "0.00"}</td>
                                    <td className="px-4 py-2 whitespace-nowrap">{item.monthWiseData?.["2025-06"]?.toFixed(2) || "0.00"}</td>
                                    <td className="px-4 py-2 whitespace-nowrap">{item.monthWiseData?.["2025-07"]?.toFixed(2) || "0.00"}</td>
                                    <td className="px-4 py-2 whitespace-nowrap">{item.monthWiseData?.["2025-08"]?.toFixed(2) || "0.00"}</td>
                                    <td className="px-4 py-2 whitespace-nowrap">{item.monthWiseData?.["2025-09"]?.toFixed(2) || "0.00"}</td>
                                    <td className="px-4 py-2 whitespace-nowrap">{item.monthWiseData?.["2025-10"]?.toFixed(2) || "0.00"}</td>
                                    <td className="px-4 py-2 whitespace-nowrap">{item.monthWiseData?.["2025-11"]?.toFixed(2) || "0.00"}</td>
                                    <td className="px-4 py-2 whitespace-nowrap">{item.monthWiseData?.["2025-12"]?.toFixed(2) || "0.00"}</td>
                                    <td className="px-4 py-2 whitespace-nowrap">{item.totalQuantity?.toFixed(2) || "0.00"}</td>
                                </tr>
                            )) : (
                                <tr>
                                    <td className="px-4 py-2 text-center">No data available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>








            <div className='row g-5 g-xl-8'>
                <div className='col-xl-12'>
                    {((c2pData?.data?.length > 0 || p2pData?.data?.length > 0) && (
                        // <div className='row'>
                        //   <div className='col-md-6'>
                        //     <div className='card p-3'>
                        //       <SankyWidget textAlign='left' label='Suppliers' data={c2pData.data || []} />
                        //     </div>
                        //   </div>
                        //   <div className='col-md-6'>
                        //     <div className='card p-3'>
                        //       <SankyWidget textAlign='left' label='Customers' data={p2pData.data || []} />
                        //     </div>
                        //   </div>
                        // </div>






                        <div className='row'>
                            <div className='col-md-12 mb-4'>
                                <div className='card p-3'>
                                    <SankyWidget textAlign='left' label='Suppliers' data={c2pData.data || []} />
                                </div>
                            </div>
                            <div className='col-md-12'>
                                <div className='card p-3'>
                                    <SankyWidget textAlign='left' label='Customers' data={p2pData.data || []} />
                                </div>
                            </div>
                        </div>



                    )) || ''}
                    <br />
                </div>
                <div className='col-xl-4'>
                    {/* <ListsWidget4
            name='Top 5 Staff'
            data={[]}  // Change {} to []
            className='card-xl-stretch mb-xl-8'
            items={5}
          /> */}
                </div>
            </div>
            {(isSupplyChainManager && (
                <>
                    <div className='row g-5 g-xl-8'>

                    </div>
                </>
            )) ||
                ''}
            {/* {!isSupplyChainManager && <TablesWidget10 className='mb-5 mb-xl-8' />} */}
            <br />
            {/* {!isSupplyChainManager && <TablesWidget13 className='mb-5 mb-xl-8' />} */}
            {/* <div className='row g-2 g-xl-8'>
        <div className=''>
          <ChartsWidget3
            data={{ label: collectedGraphData.label, data: collectedGraphData?.data }}
            name='Material collected (kgs)'
            className='card-xl-stretch mb-xl-8'
          />
        </div>
        <div className=''>
          <ChartsWidget3
            data={{ label: processGraphData.label, data: processGraphData?.data }}
            name='Material processed (kgs)'
            className='card-xl-stretch mb-xl-8'
          />
        </div>
      </div> */}
            {/* <div className=''>
        <ChartsWidget3
          data={{ label: suppliedGraphData.label, data: suppliedGraphData?.data }}
          name='Material supplied (kgs)'
          className='card-xl-stretch mb-xl-8'
        />
      </div> */}
        </>
    )
}

const FacFor: FC = () => {
    const intl = useIntl()
    const options = generateYearOptions(2015)

    const [selectedDate, setSelectedDate] = useState<any>('2025')
    return (
        <>
            <div className='flex justify-between items-center' style={{ marginTop: "-55px" }}>
                <div>
                    <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'Dashboard' })}</PageTitle>
                </div>
            </div>
            <DashboardPage year={selectedDate} />
        </>
    )
}

export { FacFor }

